import { render } from "./CaseStudy.vue?vue&type=template&id=d6be224e&scoped=true"
import script from "./CaseStudy.vue?vue&type=script&lang=js"
export * from "./CaseStudy.vue?vue&type=script&lang=js"

import "./CaseStudy.vue?vue&type=style&index=0&id=d6be224e&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6be224e"]])

export default __exports__